import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { List, ListItem } from '@mui/material';
import Button from '../Button';
import {
  BodyMenuMobile,
  ContBodyMenuMobile,
  ContFooterMenuMobile,
  ContItemsMenuMobile,
  ContItemsMenuMobileBtn,
  ContMenuMobile,
  ListaServiciosMobile,
  ImgMenu,
  ItemMenuMobile,
  ExpandIco,
  ContItemMenuMobileServices,
  ContItemMenuMobileLenguagess,
  ItemMenuMobileServices,
  ContGLobe,
  LegalLinksMobile,
  SocialLinksMobile,
  SocialLinkMobile,
  LangCode,
} from './MenuMobile.styles';
import IcoExpand from '../../assets/images/ico-expand.svg';
import icoMenu from '../../assets/images/ico-hamburger.svg';
import icoClose from '../../assets/images/ico-close.svg';
import icoOnboarding from '../../assets/images/services-icons/user-octagon.svg';
import IcoAnalisis from '../../assets/images/services-icons/note.svg';
import IcoDispersion from '../../assets/images/services-icons/direct-send.svg';
import IcoMoney from '../../assets/images/services-icons/money-3.svg';
import IcoScoring from '../../assets/images/services-icons/activity.svg';
import IcoSecurity from '../../assets/images/services-icons/shield-tick.svg';
import IcoCC from '../../assets/images/services-icons/card.svg';
import IcoNoti from '../../assets/images/services-icons/message-text.svg';
import IcoPayServces from '../../assets/images/services-icons/document-text.svg';
import IcoAutom from '../../assets/images/services-icons/candado.svg';
import GlobeIcon from '../../assets/images/globe-icon.png';
import GithubIcon from '../../assets/images/ico-github.svg';
import FacebookIcon from '../../assets/images/ico-facebook.svg';
import LinkedInIcon from '../../assets/images/ico-linkedin.svg';

const MenuMobile = () => {
  const { i18n, t } = useTranslation();
  const [onShowMenu, setOnShowMenu] = useState(false);
  const [serviciosOpen, toggleServiciosOpen] = useState(false);
  const [lenguages, setLenguages] = useState(false);
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [borderBottomPad, setBorderBottomPad] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  const isEnglish = i18n.language === 'en';
  const routes = {
    home: isEnglish ? '/en' : '/',
    about: isEnglish ? '/en/about-us' : '/nosotros',
    benefits: isEnglish ? '/en/benefits' : '/beneficios',
    core: isEnglish ? '/en/banking-core' : '/core-bancario',
    useCases: isEnglish ? '/en/credit-use-case' : '/caso-de-uso-credito',
    contact: isEnglish ? '/en/contact' : '/contacto',
    terms: isEnglish ? '/en/terms-and-conditions' : '/terminos-y-condiciones',
    privacy: isEnglish ? '/en/privacy-policy' : '/aviso-de-privacidad',
    services: {
      onboarding: isEnglish ? '/en/onboarding' : '/onboarding',
      creditAnalysis: isEnglish ? '/en/credit-analysis' : '/analisis-crediticio',
      dispersion: isEnglish ? '/en/payment-dispersion' : '/dispersion-pagos',
      collections: isEnglish ? '/en/collections' : '/cobranza',
      scoring: isEnglish ? '/en/alternative-scoring' : '/score-alternativo',
      pld: isEnglish ? '/en/anti-money-laundering' : '/pld',
      cardIssuance: isEnglish ? '/en/card-issuance' : '/emision-tarjetas',
      notifications: isEnglish ? '/en/notifications' : '/notificaciones',
      payServices: isEnglish ? '/en/pay-services' : '/pago-servicios',
      deviceLock: isEnglish ? '/en/device-lock' : '/bloqueo-dispositivos',
    },
  };

  const onShowMenuMobile = () => setOnShowMenu(!onShowMenu);
  const closeMenu = () => setOnShowMenu(false);

  const toggleContent = () => {
    toggleServiciosOpen(!serviciosOpen);
    setIsContentVisible(!isContentVisible);
    setBorderBottomPad(!borderBottomPad);
  };

  const handleChangeLanguage = (newLanguage) => {
    i18n.changeLanguage(newLanguage);
    setCurrentLanguage(newLanguage);
    setOnShowMenu(false);
  };

  return (
    <ContMenuMobile id={'ContMenuMobile'}>
      <ImgMenu
        src={onShowMenu ? icoClose : icoMenu}
        alt="img-menu"
        onClick={onShowMenuMobile}
      />
      {onShowMenu ? (
        <ContBodyMenuMobile id={'ContBodyMenuMobile'}>
          <BodyMenuMobile>
            <ContItemsMenuMobile>
              <Link to={routes.home} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                <ItemMenuMobile>Home</ItemMenuMobile>
              </Link>
              <Link to={routes.about} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                <ItemMenuMobile>{t('Nosotros')}</ItemMenuMobile>
              </Link>
              <Link to={routes.benefits} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                <ItemMenuMobile>{t('Beneficios')}</ItemMenuMobile>
              </Link>

              <ItemMenuMobile onClick={toggleContent} borderBottom={borderBottomPad}>
                {t('Servicios')}
                <ExpandIco
                  src={IcoExpand}
                  alt={isContentVisible ? 'Expandir' : 'Contraer'}
                  isContentVisible={!isContentVisible}
                />
              </ItemMenuMobile>

              {serviciosOpen && (
                <ListaServiciosMobile>
                  <Link to={routes.services.onboarding} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={icoOnboarding} alt="Onboarding" />{t('Onboarding Digital')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.creditAnalysis} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoAnalisis} alt="Análisis" />{t('Análisis Crediticio')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.dispersion} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoDispersion} alt="Dispersión" />{t('Dispersión')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.collections} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoMoney} alt="Cobranza" />{t('Cobranza')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.scoring} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoScoring} alt="Score alternativo" />{t('Análisis Score alternativo')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.pld} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoSecurity} alt="PLD" />PLD
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.cardIssuance} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoCC} alt="Emisión" />{t('Emisión de tarjetas')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.notifications} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoNoti} alt="Campaña" />{t('Campaña de notificaciones')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.payServices} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices>
                        <img src={IcoPayServces} alt="Pago" />{t('Pago de Servicios')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                  <Link to={routes.services.deviceLock} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                    <ContItemMenuMobileServices>
                      <ItemMenuMobileServices borderBottom={true}>
                        <img src={IcoAutom} alt="Candado" />{t('Candado de Smartphones')}
                      </ItemMenuMobileServices>
                    </ContItemMenuMobileServices>
                  </Link>
                </ListaServiciosMobile>
              )}

              <Link to={routes.core} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                <ItemMenuMobile>{t('Core Bancario')}</ItemMenuMobile>
              </Link>
              <Link to={routes.useCases} style={{ textDecoration: 'none' }} onClick={closeMenu}>
                <ItemMenuMobile>{t('Casos de uso')}</ItemMenuMobile>
              </Link>
              <a href="https://blog.dynamicore.io/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <ItemMenuMobile>Blog</ItemMenuMobile>
              </a>

              <ItemMenuMobile onClick={() => setLenguages(!lenguages)} borderBottom={borderBottomPad}>
                <ContGLobe>
                  <img src={GlobeIcon} alt={'Globe icon'} width={16} />
                  <LangCode>{currentLanguage === 'es' ? 'ES' : 'EN'}</LangCode>
                </ContGLobe>
                <ExpandIco
                  src={IcoExpand}
                  alt={lenguages ? 'Expandir' : 'Contraer'}
                  isContentVisible={!lenguages}
                />
              </ItemMenuMobile>
              {lenguages && (
                <ListaServiciosMobile>
                  <List disablePadding>
                    <ContItemMenuMobileLenguagess>
                      <ListItem onClick={() => handleChangeLanguage('en')} style={{ cursor: 'pointer' }}>
                        <ItemMenuMobileServices>English</ItemMenuMobileServices>
                      </ListItem>
                      <ListItem onClick={() => handleChangeLanguage('es')} style={{ cursor: 'pointer' }}>
                        <ItemMenuMobileServices>Español</ItemMenuMobileServices>
                      </ListItem>
                    </ContItemMenuMobileLenguagess>
                  </List>
                </ListaServiciosMobile>
              )}

              <ContItemsMenuMobileBtn>
                <Button
                  text={t('Contáctanos')}
                  type={'/'}
                  linkTo={routes.contact}
                  withIcon={true}
                  target={'_self'}
                  theme={'secondary'}
                  size={'b'}
                />
              </ContItemsMenuMobileBtn>
            </ContItemsMenuMobile>

            <ContFooterMenuMobile>
              <LegalLinksMobile>
                <Link to={routes.terms} onClick={closeMenu}>{t('Términos y condiciones')}</Link>
                <Link to={routes.privacy} onClick={closeMenu}>{t('Aviso de privacidad')}</Link>
              </LegalLinksMobile>
              <SocialLinksMobile>
                <SocialLinkMobile href={'https://github.com/fintcore'} target={'_blank'} rel="noreferrer">
                  <img src={GithubIcon} alt="Github Dynamicore" />
                </SocialLinkMobile>
                <SocialLinkMobile href={'https://facebook.com/dynamicore/'} target={'_blank'} rel="noreferrer">
                  <img src={FacebookIcon} alt="Facebook Dynamicore" />
                </SocialLinkMobile>
                <SocialLinkMobile href={'https://linkedin.com/company/dynamicore-system/'} target={'_blank'} rel="noreferrer">
                  <img src={LinkedInIcon} alt="Linkedin Dynamicore" />
                </SocialLinkMobile>
              </SocialLinksMobile>
            </ContFooterMenuMobile>
          </BodyMenuMobile>
        </ContBodyMenuMobile>
      ) : null}
    </ContMenuMobile>
  );
};

export default MenuMobile;
